import { useEffect, useState } from "react";
import { PlantingMaterialPackagingDDLAPI } from "../../../../../Helper/Redux/DDLSlice/DDLSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { PlantingMaterialPackagingPostAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/BeneficiaryDetailsSlice";


const AddMaterialPackagingPopup = (props) => {

    const { handleAddMaterial, Title,  M_BeneficiaryDetailsID, handleDataIsPost } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [RadioPolybag, setRadioPolybag] = useState('No')
    const [RadioCones, setRadioCones] = useState('No')
    const [RadioStumps, setRadioStumps] = useState('No')
    const [RawID, setRawID] = useState([])
    const [RawData, setRawData] = useState([])
    const [RawDataDetails, setRawDataDetails] = useState(new Map())

    // console.log("RawData",RawData);
    useEffect(() => {
        const data = {
            M_TableUserMasterID: UserID,
            Flag: "Master",
            token: token,
        }
        dispatch(PlantingMaterialPackagingDDLAPI({ data }))
    }, [])

    const { DDLData } = useSelector(state => state.PlantingMaterialPackagingDDLData)


    const handleValueChange = (newValue) => {
        if (RawID?.includes(newValue)) {
            setRawID(RawID.filter(value => value != newValue));
        } else {
            setRawID([...RawID, newValue]);
        }
    };

    const handleRawDataDetails = (e, item) => {
        const updatedRawDataDetails = new Map(RawDataDetails);
        if (e === '') {
            updatedRawDataDetails.delete(item.m_AgeID);
        } else {
            updatedRawDataDetails.set(item.m_AgeID, e);
        }
        setRawDataDetails(updatedRawDataDetails);

        const newData = Array.from(updatedRawDataDetails, ([key, value]) => key + '|' + value);
        setRawData(newData);
    }



    const handleSubmit = () => {
        const data = {
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            RawData: RawData,
            M_TableUserMasterID: UserID,
            token: token,
            handleDataIsPost

        }
        dispatch(PlantingMaterialPackagingPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.PlantingMaterialPackagingPostData)

    return (<>
        <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
            <div className="modal-dialog modal-lg" role="document"  >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ml-lg-5" id="exampleModalLongTitle">{Title}</h5>
                        <button onClick={handleAddMaterial} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body mx-4">


                        <div className="row">

                            <div className="col-12">
                                <span className="fw-bold">
                                    Select Packging Material:
                                </span>

                            </div>


                            {
                                DDLData && DDLData.table && DDLData.table.length > 0 && DDLData.table.map((i, j) =>
                                    <div className="col-12 col-lg-4 pt-3 mx-auto">
                                        <form >
                                            <input type="checkbox"
                                                className="px-3"
                                                onChange={() => handleValueChange(i.m_AgeID)}
                                                id={i.m_AgeID}
                                                name="Polybag"
                                                value={i.m_AgeID} />
                                            <label for="Polybag" className="ps-2">{i.m_AgeName} </label>
                                        </form>
                                        {
                                            (RawID?.find((id) => id == i.m_AgeID)) &&
                                            <input
                                                type="text"
                                                className="form-control mt-2 col-6"
                                                name="Polybag"
                                                placeholder=""
                                                value={RawDataDetails && RawDataDetails.get(i.m_AgeID)}
                                                onChange={(e) => handleRawDataDetails(e.target.value, i)}

                                            />

                                        }


                                    </div>
                                )}

                            <div className="col-12  d-flex justify-content-center pt-5">
                                <div className="form-group w-80 d-flex justify-content-between">

                                    <button
                                        type='button'
                                        onClick={handleSubmit}
                                        className="btn btn-outline-dark border-2 mx-2" data-ktwizard-type="action-next">
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleAddMaterial}
                                        className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>




                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default AddMaterialPackagingPopup;